import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import type { CollectorSelfProfileOptions } from './collectorSelfProfileOptions';
import { client } from '../client';
import { UserProfile, UserRoleName } from './types/UserProfile';

export const updateEmailAddress = async (
  user_id: number,
  email: string,
  userRole?: string,
  options?: CollectorSelfProfileOptions,
): Promise<UserProfile> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const useCollectorMe =
    userRole === UserRoleName.Collector && options?.collectorEditingSelf === true;
  const path = useCollectorMe
    ? '/collector/me/unverified_email'
    : `${prefix}/users/${user_id}/unverified_email`;
  const { data } = await client.patch(path, {
    unverified_email: email,
  });

  return data;
};
